import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'

// Suppress noisy Facebook iframe errors globally
const originalError = console.error;
const originalWarn = console.warn;

const isFacebookNoise = (args: unknown[]) => {
    const msg = args.map(a => typeof a === 'object' ? JSON.stringify(a) : String(a)).join(' ');
    return msg.includes('Referrer Policy') ||
        msg.includes('origin-when-cross-origin') ||
        msg.includes('fbcdn.net') ||
        msg.includes('facebook.com') ||
        msg.includes('ErrorUtils') ||
        msg.includes('Could not find element') ||
        msg.includes('DataStore') ||
        msg.includes('__elem_') ||
        msg.includes('__inst_') ||
        msg.includes('qql5zMURfET');
};

console.error = (...args) => { if (!isFacebookNoise(args)) originalError(...args); };
console.warn = (...args) => { if (!isFacebookNoise(args)) originalWarn(...args); };

createRoot(document.getElementById("root")!).render(<App />);

